// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3001u","Logo":"Toolbar_Logo__b5lrY","DesktopOnly":"Toolbar_DesktopOnly__3rY2T"};